/* eslint-disable react/react-in-jsx-scope */
import Fab from '@material-ui/core/Fab';
import { makeStyles } from '@material-ui/core/styles';
import Android from '@material-ui/icons/Android';
import { rithumAgentStartTaskEntityPermission } from '@internal/plugin-rithum-agent-common';
import { usePermission } from '@backstage/plugin-permission-react';
import { useState } from 'react';
import { RithumAgentPanel } from './RithumAgentPanel';
import { useOptionalEntityFromRoute } from './useOptionalEntityFromRoute';

const useStyles = makeStyles(theme => ({
  fab: {
    position: 'fixed',
    right: theme.spacing(3),
    bottom: theme.spacing(3),
    zIndex: theme.zIndex.drawer + 1,
  },
}));

type Props = {
  children?: React.ReactNode;
};

/**
 * Global shell: floating bot control + Agent Tasks dialog.
 */
export function RithumAgentRootWrapper(props: Props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { entityRef: entityRefFromRoute } = useOptionalEntityFromRoute();
  const { allowed, loading } = usePermission({
    permission: rithumAgentStartTaskEntityPermission,
    resourceRef: entityRefFromRoute,
  });

  const showFab = !entityRefFromRoute || loading || allowed;

  return (
    <>
      {props.children}
      {!open && showFab && (
        <Fab
          className={classes.fab}
          color="primary"
          aria-label="Open agent tasks"
          onClick={() => setOpen(true)}
        >
          <Android />
        </Fab>
      )}
      <RithumAgentPanel open={open} onClose={() => setOpen(false)} />
    </>
  );
}
